export default __webpack_public_path__ + "static/media/banner-principal-mobile.719281a1.jpg";